import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import {
  SuchprofilPage,
  ImpressumPage,
  DatenschutzPage,
  KontaktPage,
  WiderrufPage,
  NotFoundPage,
  ErbenRechnerPage,
  ConfirmationPage,
  ProfileConfirmedPage,
  ProfileManagementPage,
  UnsubscribeSuccessPage,
  KaeuferRadarPage,
  BewertungBestaetigung,
  VerkaufenAgrarflaechenPage,
  NewsletterBestaetigung,
  NewsletterPage,
  KIAssistentPage,
  BestaetigungAbgelaufenPage,
  FlaechenbewertungPage,
  KiVorbewertungPage,
  ImmobilienPage,
  MeineGebotePage,
  PropertyDetailPage,
  LandkreisDetailPage,
  RatgeberPage,
  RatgeberLexikonPage,
  RatgeberVideosPage,
  RatgeberArtikelListPage,
  RatgeberDownloadsPage,
  RatgeberArtikelPage,
  BieterverfahrenPage
} from './lazyImports';

// ========================================
// PUBLIC ROUTES
// Alle öffentlich zugänglichen Seiten
// ========================================

const publicRoutes = [
  // Hauptseiten
  <Route key="bewertung" path="/bewertung" element={<FlaechenbewertungPage />} />,
  <Route key="flaechenbewertung" path="/flaechenbewertung" element={<FlaechenbewertungPage />} />,
  <Route key="ki-vorbewertung" path="/ki-vorbewertung" element={<KiVorbewertungPage />} />,
  <Route key="ki-vorbewertung-id" path="/ki-vorbewertung/:id" element={<KiVorbewertungPage />} />,
  <Route key="ratgeber" path="/ratgeber" element={<RatgeberPage />} />,
  <Route key="ratgeber-lexikon" path="/ratgeber/lexikon" element={<RatgeberLexikonPage />} />,
  <Route key="ratgeber-videos" path="/ratgeber/videos" element={<RatgeberVideosPage />} />,
  <Route key="ratgeber-artikel-list" path="/ratgeber/artikel" element={<RatgeberArtikelListPage />} />,
  <Route key="ratgeber-downloads" path="/ratgeber/downloads" element={<RatgeberDownloadsPage />} />,
  <Route key="ratgeber-artikel" path="/ratgeber/:slug" element={<RatgeberArtikelPage />} />,
  <Route key="blog" path="/blog" element={<RatgeberPage />} />,
  
  // Immobilien
  <Route key="immobilien" path="/immobilien" element={<ImmobilienPage />} />,
  <Route key="immobilie-detail" path="/immobilie/:slug" element={<PropertyDetailPage />} />,
  <Route key="angebote-redirect" path="/angebote" element={<Navigate to="/immobilien" replace />} />,
  <Route key="angebote-slug-redirect" path="/angebote/:slug" element={<Navigate to={`/immobilie/${window.location.pathname.split('/').pop()}`} replace />} />,
  <Route key="meine-gebote" path="/meine-gebote" element={<MeineGebotePage />} />,
  <Route key="bieterverfahren" path="/bieterverfahren" element={<BieterverfahrenPage />} />,
  
  // Tools & Services
  <Route key="suchprofil" path="/suchprofil" element={<SuchprofilPage />} />,
  <Route key="nachlass-planer" path="/nachlass-planer" element={<ErbenRechnerPage />} />,
  <Route key="erben-rechner" path="/erben-rechner" element={<ErbenRechnerPage />} />,
  <Route key="kaeufer-radar" path="/kaeufer-radar" element={<KaeuferRadarPage />} />,
  <Route key="ki-assistent" path="/ki-assistent" element={<KIAssistentPage />} />,
  
  // Kontakt & Verkauf
  <Route key="kontakt" path="/kontakt" element={<KontaktPage />} />,
  <Route key="verkaufen-agrarflaechen" path="/verkaufen-agrarflaechen" element={<VerkaufenAgrarflaechenPage />} />,
  <Route key="makler-kontakt-redirect" path="/makler-kontakt" element={<Navigate to="/verkaufen-agrarflaechen" replace />} />,
  
  // Legal
  <Route key="impressum" path="/impressum" element={<ImpressumPage />} />,
  <Route key="datenschutz" path="/datenschutz" element={<DatenschutzPage />} />,
  <Route key="widerruf" path="/widerruf" element={<WiderrufPage />} />,
  
  // Newsletter
  <Route key="newsletter" path="/newsletter" element={<NewsletterPage />} />,
  <Route key="newsletter-bestaetigung" path="/newsletter/bestaetigen" element={<NewsletterBestaetigung />} />,
  
  // Bestätigungen & Profile Management
  <Route key="confirm-token" path="/confirm/:token" element={<ConfirmationPage />} />,
  <Route key="suchprofil-bestaetigt" path="/suchprofil-bestaetigt" element={<ProfileConfirmedPage />} />,
  <Route key="profile-token" path="/profile/:token" element={<ProfileManagementPage />} />,
  <Route key="unsubscribe-token" path="/unsubscribe/:token" element={<ProfileManagementPage />} />,
  <Route key="unsubscribe-success" path="/unsubscribe-success" element={<UnsubscribeSuccessPage />} />,
  <Route key="bewertung-bestaetigung" path="/bewertung-bestaetigung" element={<BewertungBestaetigung />} />,
  <Route key="bestaetigung-abgelaufen" path="/bestaetigung-abgelaufen" element={<BestaetigungAbgelaufenPage />} />,
  
  // Landkreis SEO Pages - Dynamic Content System
  <Route key="landkreis-detail" path="/:bundesland/:landkreis/:type" element={<LandkreisDetailPage />} />,
  
  // 404 - MUST be last
  <Route key="404" path="*" element={<NotFoundPage />} />
];

export default publicRoutes;
